import { render, staticRenderFns } from "./SummaryStrengths.vue?vue&type=template&id=5094537b&scoped=true&"
import script from "./SummaryStrengths.vue?vue&type=script&lang=js&"
export * from "./SummaryStrengths.vue?vue&type=script&lang=js&"
import style0 from "./SummaryStrengths.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SummaryStrengths.vue?vue&type=style&index=1&id=5094537b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5094537b",
  null
  
)

export default component.exports